module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "svi-housing--dataset-cover.5f46fb37.png";